import React, { type ButtonHTMLAttributes, type ReactNode } from 'react';
import { tokens } from './tokens';
import { tapHaptic } from './haptics';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

const variantColors: Record<string, string> = {
  primary: tokens.colors.primary,
  secondary: tokens.colors.secondary,
  success: tokens.colors.success,
  danger: tokens.colors.error,
};

const sizeStyles: Record<string, React.CSSProperties> = {
  sm: { padding: '6px 12px', fontSize: tokens.fontSize.sm },
  md: { padding: '10px 20px', fontSize: tokens.fontSize.md },
  lg: { padding: '14px 28px', fontSize: tokens.fontSize.lg },
};

export function Button({ variant = 'primary', size = 'md', children, style, onClick, ...props }: ButtonProps): React.ReactElement {
  // Light haptic on every press (native only; no-op on web). The browser does
  // not fire onClick for a disabled button, so disabled presses stay silent.
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    tapHaptic();
    onClick?.(e);
  };
  return React.createElement(
    'button',
    {
      style: {
        backgroundColor: variantColors[variant],
        color: '#FFFFFF',
        border: 'none',
        borderRadius: tokens.borderRadius.md,
        cursor: 'pointer',
        fontWeight: 600,
        transition: 'opacity 0.2s',
        ...sizeStyles[size],
        ...style,
      },
      onClick: handleClick,
      ...props,
    },
    children
  );
}
